import { render } from "./통증클리닉.vue?vue&type=template&id=763899ea"
import script from "./통증클리닉.vue?vue&type=script&lang=js"
export * from "./통증클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__